<template>
    <div class="c-subnav-modal">
        <ul>
            <li
                v-for="item in items"
                :key="item.value"
                @click.capture="handleClick(item)"
                :class="{ active: item.value == entityPlaybookStatusId }"
            >
                <a slot="default" class="mx-3 py-3 util-full-w util-block">
                    {{ item.title }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        entityPlaybookStatusId: Number,
    },
    data() {
        return {
            items: [
                {
                    value: null,
                    title: "All",
                },
                {
                    value: 1,
                    title: "In Progress",
                },
                {
                    value: 2,
                    title: "Completed",
                },
                {
                    value: 3,
                    title: "Cancelled",
                },
                {
                    value: 4,
                    title: "Paused",
                },
            ],
        };
    },
    methods: {
        handleClick(arg) {
            this.$emit("update:entity-playbook-status-id", arg.value);
        },
    },
};
</script>
